export const isCardPermanentlyBlocked = (status?: string | null) =>
	["blocked", "closed"].includes((status || "").toLowerCase())

/** Backend 409 for top-up, withdraw, freeze and unfreeze while cards/block is running. */
export const CARD_BLOCKING_ERROR_CODE = 2501

export const isCardBlockingError = (error?: { code?: number } | null) =>
	error?.code === CARD_BLOCKING_ERROR_CODE

/** cards/block is async: the status stays active/frozen until the issuer confirms, `blocking` marks the run. */
export const isCardBlocking = (card?: { status?: string | null; blocking?: boolean } | null) =>
	Boolean(card?.blocking) && !isCardPermanentlyBlocked(card?.status)

export const CARD_BLOCKING_LABEL = "Blocking…"

/** Status for badges: a running block reads as "Blocking…" (warn tone) instead of the API status. */
export const cardDisplayStatus = (card: { status?: string | null; blocking?: boolean }) =>
	isCardBlocking(card) ? CARD_BLOCKING_LABEL : card.status
